import AppService from '../../services/app.service';
import CoaModel from '../coa/coa-model';
import TransactionModel from '../transaction/transaction-model';

export default class JournalModel {
    id: number;
    name: string;
    description: string;
    status: string;
    journaldate: any;
    seq: number;
    sign: string;    
    value: number;
    coa: any;
    coaCaption: string;
    transaction: any;
    transactionCaption: string;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'draft';
        this.journaldate = datarow.journaldate;
        this.seq = datarow.seq;
        this.sign = datarow.sign || 'debet';
        this.value = datarow.value;
        let coa = datarow.coa?.data? new CoaModel(datarow.coa?.data) : datarow.coa;
        this.coa = coa?.id;
        this.coaCaption = coa.name;
        let transaction = datarow.transaction?.data? new TransactionModel(datarow.transaction?.data) : datarow.transaction;
        this.transaction = transaction?.id;
        this.transactionCaption = transaction.name;
    } 

    public static endPoint: string = 'journals' 
    public static endPointFilter: string = '?populate=*&sort=name&filters[transaction]=';
    public static url: string = '/journal';
    public static caption: string = 'Journal Detail';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'draft',     
        journaldate: AppService.dateCurrent(),
        seq: 0,
        sign: 'debet',    
        value: 0,
        coa: null,
        coaCaption: '',
        transaction: null,
        transactionCaption: '',
  
        }
    }
    
    public static columns = [
        { name: 'coaCaption', caption: 'COA' },
        { name: 'sign', caption: 'Debet/Credit' },
        { name: 'value', caption: 'Value', type: 'money' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]

    public static optionStatus = [
        { name: 'draft', caption: 'Draft' },
        { name: 'approved', caption: 'Approved' },
        { name: 'rejected', caption: 'Rejected' },
    ]
    
    public static optionSign = [
        { name: 'debet', caption: 'Debet' },
        { name: 'credit', caption: 'Credit' },
    ]


}